// extracted by mini-css-extract-plugin
export default {"pagnationList":"pagnationComponet_pagnationList__-Q917","pageNum":"pagnationComponet_pageNum__Ai5zv"};